import React, { Component } from 'react';
import { Card, Grid } from "@material-ui/core";
import { PolicyRounded, BookmarksSharp, LiveTvTwoTone } from '@material-ui/icons';
class projectContainer extends Component {
  constructor (props) {
    super(props);
    this.state = {
      projects: [
        {
          name: "Flask todo App",
          live: 'https://github.com/kompanycoder/flask-app',
          github: 'https://github.com/kompanycoder/flask-app'
        },
        {
          name: "React BookShelf App",
          live: 'https://github.com/kompanycoder/bookShelf',
          github: 'https://github.com/kompanycoder/bookShelf'
        },
        {
          name: "Angular Landing-env App",
          live: 'https://github.com/kompanycoder/landing-env',
          github: 'https://github.com/kompanycoder/landing-env'
          
        },
        {
          name: "Vue Javascipt Game",
          live: 'https://github.com/kompanycoder/javascript-vue-game',
          github: 'https://github.com/kompanycoder/javascript-vue-game'
        },
        {
          name: "Angular Real-estate App",
          live: 'https://github.com/kompanycoder/real-estate',
          github: 'https://github.com/kompanycoder/real-estate',
        }
      ]
    };

  }
  render(){
    return (
      <Grid className="container-projects" variant="contained" color="default">
        <h4 className="projects-title"><BookmarksSharp></BookmarksSharp> Projects</h4>
        <div className="projects-container" spacing={2}>
        {
          this.state.projects.map((project, i) => (
          
              <Card className="project" key={i}>
                <div className="project-icons">
                <a href={project.github} target="_blank" rel="noopener noreferrer" className="project-link"><PolicyRounded className="project-fill"></PolicyRounded> </a>
                <a href={project.live} target="_blank" rel="noopener noreferrer" className="project-link"><LiveTvTwoTone className="project-fill"></LiveTvTwoTone> </a>
                </div>
                <p className="project-description">{project.name}</p>
              </Card>
          ))
        } </div>       
      </Grid>
      )
  }
};

export default projectContainer;